import React, { useState } from 'react';

// A number box that behaves (Ryan, Oct 23 2026, the Trenching boxes): a 0 shows as an empty box
// with a grey 0, so typing replaces it instead of making "05"; tapping in selects what's there so
// typing writes over it; `money` puts a $ inside the box. onChange gets the input's event, same as
// a plain <input>. keepZero: show a real 0 (where empty means something else, e.g. "work it out").
export default function NumBox({ value, onChange, onBlur, money = false, keepZero = false, style = {}, placeholder, ...rest }) {
  const [typing, setTyping] = useState(null);   // what's in the box while it has focus
  const blank = value == null || value === '' || (!keepZero && Number(value) === 0);
  const shown = typing != null ? typing : (blank ? '' : String(value));
  const box = (
    <input type="number" step="any" {...rest} value={shown}
      placeholder={placeholder != null ? placeholder : money ? '0.00' : '0'}
      onFocus={e => { setTyping(shown); e.target.select(); }}
      onChange={e => { setTyping(e.target.value); onChange && onChange(e); }}
      onBlur={e => { setTyping(null); onBlur && onBlur(e); }}
      style={money ? { ...style, paddingLeft: 18 } : style} />
  );
  if (!money) return box;
  return (
    <span style={{ position: 'relative', display: 'inline-block' }}>
      <span style={{ position: 'absolute', left: 7, top: '50%', transform: 'translateY(-50%)', color: '#6b7280', fontSize: 13, pointerEvents: 'none' }}>$</span>
      {box}
    </span>
  );
}
